export interface StatisticState {
    cdpStaticDetail: CdpDetailItem[];
    cdpStatisticDetailFlag?: string;
    cdpStatisticGroup: CdpGroupItem[];
    // cdpStatisticGroupMessageCount: number;
    cdpGroupings: {
        cdpGroup: string[];
        cdpGroupByOptionally: string[];
    };
}

export interface CdpDetailItem {
    id: string;
    create_date: string;
    partner: string;
    broker_account_login?: string;
    message_type?: string;
    status: string;
    ext_event_profile_id?: string;
    ext_client_profile_id?: string;
    ext_campaign_id?: string;
    ext_request_id?: string;
    error_code?: number;
    status_description?: string;
    connection_type?: string;
    partner_user_login?: string;
    ext_add_param1?: string;
    ext_add_param2?: string;
    ext_add_param3?: string;
    ext_add_param4?: string;
    ext_add_param5?: string;
}

export class CdpDetailItemInfo {
    id: number | null = null;
    create_date: string | null = null;
    partner: string | null = null;
    partner_user_login?: string = undefined;
    broker_account_login?: string = undefined;
    connection_type?: string = undefined;
    message_type?: string = undefined;
    ext_request_id: string | null = null;
    ext_event_profile_id?: string = undefined;
    ext_event_profile_data?: Record<string, any> = undefined;
    ext_client_profile_id?: string = undefined;
    ext_client_profile_data?: Record<string, any> = undefined;
    ext_campaign_id?: string = undefined;
    ext_add_param1?: string = undefined;
    ext_add_param2?: string = undefined;
    ext_add_param3?: string = undefined;
    ext_add_param4?: string = undefined;
    ext_add_param5?: string = undefined;
    ext_add_params?: Array<{
        name: string;
        value: string;
    }> = undefined;
    processed_date: string | null = null;
    status: string | null = null;
    error_code?: number = undefined;
    status_description?: string = undefined;
    server_info: string | null = null;
}

export class CdpDetailFilterParams {
    id?: string = undefined;
    date_from: string;
    date_to: string;
    partner?: string = undefined;
    broker_account_login?: string = undefined;
    message_type?: string = undefined;
    status?: string = undefined;
    ext_client_profile_id?: string = undefined;
    ext_client_profile_data?: any[] = [];
    ext_event_profile_id?: string = undefined;
    ext_event_profile_data?: any[] = [];
    ext_campaign_id?: string = undefined;
    ext_request_id?: string = undefined;
    error_code?: number = undefined;
    status_description?: string = undefined;
    connection_type?: string = undefined;
    partner_user_login?: string = undefined;
    ext_add_param1?: string = undefined;
    ext_add_param2?: string = undefined;
    ext_add_param3?: string = undefined;
    ext_add_param4?: string = undefined;
    ext_add_param5?: string = undefined;
    page_number: number = 1;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.ext_client_profile_data = [];
        this.ext_event_profile_data = [];
        this.page_number = 1;
    }
}

export interface CdpGroupItem {
    new: number;
    total: number;
    processed: number;
    error: number;
    date?: string;
    partner?: string;
    broker_account_login?: string;
    message_type?: string;
    connection_type?: string;
    ext_event_profile_id?: string;
    partner_user_login?: string;
    server_info?: string;
}

export class CdpGroupFilterParams {
    date_from: string;
    date_to: string;
    group_by: string;
    partner?: string = undefined;
    broker_account_login?: string = undefined;
    message_type?: string = undefined;
    ext_event_profile_id?: string = undefined;
    connection_type?: string = undefined;
    ext_campaign_id?: string = undefined;
    partner_user_login?: string = undefined;
    server_info?: string = undefined;

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
    }
}